import {
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Skeleton,
  Switch,
} from '@chakra-ui/react'

import { useUser } from '@/react-query/user'
import {
  useUpdateUserSettings,
  useUserSettings,
} from '@/react-query/user-settings'
import Card from '@/views/components/Card/Card'

export const EmailNotifications = () => {
  const userSettings = useUserSettings()
  const updateUserSettings = useUpdateUserSettings()

  const user = useUser()
  return (
    <Card w={'100%'} p={6} px={10}>
      <Heading size={'md'}>Email notifications</Heading>
      <HStack w="100%" wrap={'wrap'} spacing={8} rowGap={4} mt={8}>
        <FormControl display={'inline-flex'} alignItems={'center'} w={'auto'}>
          <Skeleton
            rounded={'1.25rem'}
            isLoaded={!userSettings.isLoading}
            startColor="#f5f5f5"
            endColor="#d7d7d7"
          >
            <Switch
              id="enable-email-notifications"
              isChecked={userSettings.data?.enableEmailNotifications}
              onChange={(event) => {
                event.preventDefault()
                updateUserSettings.mutate({
                  enableEmailNotifications:
                    !userSettings.data?.enableEmailNotifications,
                })
              }}
              size={'lg'}
              variant={'brand-black'}
              isDisabled={userSettings.isLoading}
            />
          </Skeleton>
          <FormLabel htmlFor="enable-email-notifications" mb="0" ml={'4'}>
            Notify <b>{user.data?.email}</b> when the transcript is ready
          </FormLabel>
        </FormControl>
      </HStack>
    </Card>
  )
}
